/**
 * J4K Collection — Nike-style filter toggle + AJAX filtering
 * Uses theme's existing filter form snippet (collection-grid-filters-form)
 * and product grid snippet (product-grid-item) for full compatibility.
 *
 * Mobile: Full-screen drawer overlay (Nike-style)
 * Desktop: Inline sidebar collapse toggle
 */
(function () {
  'use strict';

  var HIDDEN_CLASS = 'j4k-collection--filters-hidden';
  var OPEN_CLASS = 'j4k-collection--filters-open';
  var BODY_LOCK_CLASS = 'j4k-filters-open';
  var STORAGE_KEY = 'j4k-filters-hidden';
  var MOBILE_BREAKPOINT = 769;

  var container = document.getElementById('j4k-collection');
  if (!container) return;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  /* ---- Mobile drawer open/close ---- */
  function openDrawer() {
    container.classList.add(OPEN_CLASS);
    document.body.classList.add(BODY_LOCK_CLASS);
  }

  function closeDrawer() {
    container.classList.remove(OPEN_CLASS);
    document.body.classList.remove(BODY_LOCK_CLASS);
  }

  /* ---- Filter sidebar toggle ---- */
  var toggleBtn = container.querySelector('[data-j4k-toggle-filters]');
  if (toggleBtn) {
    var label = toggleBtn.querySelector('.j4k-collection__filter-toggle-label');
    var hideText = label ? label.getAttribute('data-hide-text') : 'Hide Filters';
    var showText = label ? label.getAttribute('data-show-text') : 'Show Filters';

    // Restore saved state (desktop only)
    if (!isMobile() && sessionStorage.getItem(STORAGE_KEY) === 'true') {
      container.classList.add(HIDDEN_CLASS);
      toggleBtn.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = showText;
    }

    // On mobile, button just says "Filter"
    if (isMobile() && label) {
      label.textContent = 'Filter';
    }

    toggleBtn.addEventListener('click', function () {
      if (isMobile()) {
        openDrawer();
      } else {
        var isHidden = container.classList.toggle(HIDDEN_CLASS);
        toggleBtn.setAttribute('aria-expanded', String(!isHidden));
        if (label) label.textContent = isHidden ? showText : hideText;
        sessionStorage.setItem(STORAGE_KEY, String(isHidden));
      }
    });
  }

  /* ---- Mobile drawer close button ---- */
  var closeBtn = container.querySelector('[data-j4k-close-filters]');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  /* ---- Mobile overlay click to close ---- */
  var overlay = container.querySelector('[data-j4k-drawer-overlay]');
  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  /* ---- Escape key to close drawer ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && container.classList.contains(OPEN_CLASS)) {
      closeDrawer();
    }
  });

  /* ---- Initialize theme components on page load ---- */
  initThemeComponents(container);

  /* ---- Filter form change listener (theme's .filter-form + .tag__input) ---- */
  var filterForm = container.querySelector('.filter-form');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.classList.contains('tag__input')) {
        submitFilters();
      }
    });
  }

  /* ---- Sort dropdown ---- */
  var sortSelect = container.querySelector('#j4k-SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      submitFilters();
    });
  }

  function initPriceRanges(root) {
    if (!window.theme || !theme.PriceRange) return;
    var priceRanges = root.querySelectorAll('.price-range');
    priceRanges.forEach(function (el) {
      var slider = el.querySelector('.price-range__slider');
      if (slider && !slider.classList.contains('noUi-target')) {
        new theme.PriceRange(el);
      }
    });
  }

  function initCollapsibles() {
    if (window.theme && typeof theme.collapsibles === 'function') {
      theme.collapsibles();
    } else if (window.theme && typeof theme.initCollapsibles === 'function') {
      theme.initCollapsibles();
    }
  }

  function initThemeComponents(root) {
    initCollapsibles();

    // Try price range immediately; if theme.PriceRange isn't ready yet, poll for it
    if (window.theme && theme.PriceRange) {
      initPriceRanges(root);
    } else {
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (window.theme && theme.PriceRange) {
          clearInterval(interval);
          initPriceRanges(root);
          initCollapsibles();
        } else if (attempts > 40) {
          clearInterval(interval);
        }
      }, 250);
    }
  }

  function submitFilters() {
    var params = new URLSearchParams();

    // Gather checked filter inputs (theme's .tag__input class)
    var inputs = container.querySelectorAll('.tag__input:checked');
    inputs.forEach(function (input) {
      params.append(input.name, input.value);
    });

    // Gather price range inputs
    var priceInputs = container.querySelectorAll('.price-range__input');
    priceInputs.forEach(function (input) {
      if (input.value) {
        params.append(input.name, input.value);
      }
    });

    // Sort
    if (sortSelect && sortSelect.value) {
      params.set('sort_by', sortSelect.value);
    }

    var url = window.location.pathname + '?' + params.toString();

    // Close mobile drawer after filter submission
    if (isMobile()) {
      closeDrawer();
    }

    // AJAX fetch
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.getElementById('CollectionAjaxContent');
        var currentContent = document.getElementById('CollectionAjaxContent');

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;

          // Re-init lazy images — force browser to load them
          currentContent.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
            img.loading = 'eager';
          });
          currentContent.querySelectorAll('img[data-src]').forEach(function (img) {
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
          });
          currentContent.querySelectorAll('img[data-srcset]').forEach(function (img) {
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
            }
          });

          // Re-init theme's section JS if available
          if (window.theme && typeof theme.reinitSection === 'function') {
            theme.reinitSection('collection-grid');
          }
          if (window.theme && typeof theme.sections === 'object' && theme.sections.reinit) {
            theme.sections.reinit('collection-grid');
          }

          // Re-init theme components in new content
          initThemeComponents(currentContent);

          // Re-init filter form change listener
          var newForm = currentContent.querySelector('.filter-form');
          if (newForm) {
            newForm.addEventListener('change', function (ev) {
              if (ev.target.classList.contains('tag__input')) {
                submitFilters();
              }
            });
          }

          // Re-bind mobile drawer close button and overlay after AJAX
          var newCloseBtn = currentContent.querySelector('[data-j4k-close-filters]');
          if (newCloseBtn) {
            newCloseBtn.addEventListener('click', closeDrawer);
          }
          var newOverlay = currentContent.querySelector('[data-j4k-drawer-overlay]');
          if (newOverlay) {
            newOverlay.addEventListener('click', closeDrawer);
          }
        }

        // Update URL without reload
        window.history.pushState({}, '', url);

        // Update active filter tags
        var newActiveFilters = doc.querySelector('.j4k-collection__active-filters');
        var currentActiveFilters = document.querySelector('.j4k-collection__active-filters');
        if (newActiveFilters) {
          if (currentActiveFilters) {
            currentActiveFilters.outerHTML = newActiveFilters.outerHTML;
          } else {
            var header = document.querySelector('.j4k-collection__header');
            if (header) {
              header.insertAdjacentHTML('afterend', newActiveFilters.outerHTML);
            }
          }
        } else if (currentActiveFilters) {
          currentActiveFilters.remove();
        }

        // Update product count in title
        var newTitle = doc.querySelector('.j4k-collection__title');
        var currentTitle = document.querySelector('.j4k-collection__title');
        if (newTitle && currentTitle) {
          currentTitle.innerHTML = newTitle.innerHTML;
        }

        // Notify infinite scroll (and other listeners) that collection was reloaded
        document.dispatchEvent(new CustomEvent('collection:reloaded'));
      })
      .catch(function (err) {
        // Fallback: navigate directly
        window.location.href = url;
      });
  }

  // Handle browser back/forward
  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();
